import { render, staticRenderFns } from "./MoveSubmissionPagePopup.vue?vue&type=template&id=109dd3b6&"
import script from "./MoveSubmissionPagePopup.vue?vue&type=script&lang=js&"
export * from "./MoveSubmissionPagePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports